import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Core2Config } from '../shared/core2Config';
import { ApiVisa } from '../shared/api-visa.model';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../shared/api-response.model';
import { MyEInvoiceToIrbContainerContainerModel } from '../../../../../models/aggregates/e-invoice/my-einvoice-to-irb-hdr-container.model';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { BaseApiTemplateService } from '../shared';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class MyEInvoiceToIRBHdrLinesService extends BaseApiPublicLoginTemplateService<MyEInvoiceToIrbContainerContainerModel, MyEInvoiceToIrbContainerContainerModel, MyEInvoiceToIrbContainerContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/e-invoice/to-irbs/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/e-invoice/to-irbs/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/e-invoice/to-irbs/backoffice-ep'
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/e-invoice/to-irbs/' + BaseApiTemplateService.LOGIN_EP
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/e-invoice/to-irbs/' + BaseApiTemplateService.LOGIN_ENTITY_EP
    this.httpClient = http;
  }

  submitToLHDN(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/e-invoice/to-irbs/submit-to-lhdn/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public printJasperPdf(
    guid: string,
    visa: ApiVisa,
  ): Observable<Blob> {
    let url;
    url =
      visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "fi/e-invoice/to-irbs/print-jasper-pdf/" + guid;
    return this.httpClient.get<Blob>(
      url,
      this.getHttpHeaderBlob(visa)
    );
  }

  public printJasperPdfCompanyPrintableFormt(
    guid: string,
    visa: ApiVisa,
  ): Observable<Blob> {
    let url;
    url =
      visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "fi/e-invoice/to-irbs/company-auto-print-jasper-pdf/" + guid;
    return this.httpClient.get<Blob>(
      url,
      this.getHttpHeaderBlob(visa)
    );
  }

  public printJasperPdfV2(guid: string,visa: ApiVisa): Observable<{ blob: Blob; filename?: string }> {
    let url;
    url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "fi/e-invoice/to-irbs/print-jasper-pdf/" + guid;
    return this.httpClient
    .get(url, this.getHttpHeaderBlobV2(visa))
    .pipe(
      map((response) => {
        const blob = response.body;
        let filename: string | undefined;
        const contentDisposition = response.headers.get('Content-Disposition');
        if (contentDisposition) {
          const matches = /filename="([^"]+)"/.exec(contentDisposition);
          if (matches && matches[1]) {
            filename = matches[1];
          }
        }
        return { blob, filename };
      })
    );
  }

  public getHttpHeaderBlobV2(apiVisa: ApiVisa, params?: HttpParams) {
    const httpOptions = {
      headers: new HttpHeaders({
        authorization: apiVisa.jwt_secret,
        tenantCode: apiVisa.tenantCode
      }),
      params: params,
      responseType: 'blob' as 'blob',
      observe: 'response' as 'response'
    };
    return httpOptions;
  }

  saveAndResubmit(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/e-invoice/to-irbs/save-and-resubmit/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  resubmitAsNewEinvoice(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/e-invoice/to-irbs/resubmit-as-new-einvoice/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  refreshToIrbToUpdateDocumentStatus(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/e-invoice/to-irbs/refresh-lhdn-document-status/backoffice-ep';
    let endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/e-invoice/to-irbs/refresh-lhdn-document-status/backoffice-ep';
    if (visa.api_domain_url) {
      customUrl = visa.api_domain_url + endpoint_path;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  resendEmail(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/e-invoice/to-irbs/resend-email-with-pdf/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
